module.exports = __webpack_public_path__ + "img/Pista_0018_2.af148950.png";